import React from 'react'
import styles from '@/styles/shared/CategoryBanner.module.css'
import Link from 'next/link'

// Page title for section index pages, set straight on the page's background photo.
// `data-banner` lets Container drop its top margin so the title sits on the photo.
const CategoryBanner = ({ backHref, backText, heading, description }) => {
  return (
    <div className={`${styles.fullbanner}`} data-banner="category">
      <div className={`${styles.banner}`}>
        {backHref && (
          <Link href={backHref} className={`${styles.back}`}>{backText}</Link>
        )}
        <h1 className={`${styles.heading}`}>{heading}</h1>
        {description && <p className={`${styles.description}`}>{description}</p>}
      </div>
    </div>
  )
}

export default CategoryBanner
